// extracted by mini-css-extract-plugin
module.exports = {"sales-unit-sizes-main-wrapper":"SalesUnitSizes_sales-unit-sizes-main-wrapper__gX8TM"};